module.exports = ".textDec {\n  text-decoration: none; }\n\n.textRight {\n  text-align: right; }\n\n.mat-form-field {\n  width: 150px; }\n"